// Narration: recorded Sage clips for every fixed line, keyed by a fingerprint of the text.
// The generator (scripts/voice-gen.mjs) uses the same normalize + hash, so the app and the
// generator always agree on which file belongs to which sentence.

/** collapse whitespace and quote styles so tiny formatting differences still match */
export function normalizeLine(text: string): string {
  return text
    .replace(/[‘’]/g, "'")
    .replace(/[“”]/g, '"')
    .replace(/[–—]/g, '-')
    .replace(/\s+/g, ' ')
    .trim();
}

/** FNV-1a 32-bit, as 8 hex chars. Small, fast, identical in node and the browser. */
export function lineKey(text: string): string {
  const s = normalizeLine(text).toLowerCase();
  let h = 0x811c9dc5;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return (h >>> 0).toString(16).padStart(8, '0');
}

let index: Set<string> | null = null;
let loading: Promise<void> | null = null;

/** load the list of recorded lines (non-blocking; until it arrives the phone voice is used) */
export function preloadVoice(base = '/voice/'): Promise<void> {
  if (loading) return loading;
  loading = fetch(base + 'index.json', { cache: 'no-cache' })
    .then(r => (r.ok ? r.json() : []))
    .then((keys: string[]) => { index = new Set(keys); })
    .catch(() => { index = new Set(); });
  return loading;
}

let current: HTMLAudioElement | null = null;

export function stopVoice() {
  if (current) { current.pause(); current = null; }
}

/** Play the recording for this line. Returns false when there is none, so the caller can fall back. */
export function playLine(text: string, base = '/voice/'): boolean {
  if (!index) return false;
  const key = lineKey(text);
  if (!index.has(key)) return false;
  stopVoice();
  const a = new Audio(`${base}${key}.ogg`);
  current = a;
  a.play().catch(() => { /* autoplay blocked or offline: silent, the text is on screen */ });
  return true;
}
